<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8">
                    <h2>导航</h2>
                    <el-row>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/chara_list" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="far fa-address-card" />角色
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/relation_list" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="fa-solid fa-people-pulling" />关系
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/closet_list/closet" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="fas fa-tshirt" />服设
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/article_list" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="far fa-copy" />文档
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/gallery_list" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="far fa-images" />图库
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/contact" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="fa-regular fa-envelope" />联系
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/log" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="fa-regular fa-calendar" />日志
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/link" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="fa-regular fa-bookmark" />外站
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/height" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="fa-regular fa-bookmark" />身高对比
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <router-link to="/pic" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <i class="fa-regular fa-bookmark" />图片处理
                                </el-card>
                            </router-link>
                        </el-col>
                    </el-row>
                    <h2>请选择你感兴趣的世界观</h2>
                    <el-row>
                        <el-col :xs="12" :sm="6">
                            <router-link to="/article/CSPA特别行动组行动报告_故事背景" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <template #footer>CSPA特别行动组行动报告</template>
                                    <el-image style="width: 100%"
                                        src="https://img.helloworldend.top/gallery/241031-01-%E8%92%82%E8%8A%99%EF%BC%9B%E8%B6%8A%E6%98%8E%EF%BC%9B%E6%B2%88%E6%82%A6%EF%BC%9B%E7%88%B1%E4%B8%BD%E4%B8%9D-h.jpg"
                                        fit="cover" />
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="6">
                            <router-link to="/article/泰尔兰大陆环游记_故事背景" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <template #footer>泰尔兰大陆环游记</template>
                                    <el-image style="width: 100%"
                                        src="https://img.helloworldend.top/gallery/260209-01-%E6%A0%BC%E9%9B%B7%E8%A5%BF%E4%BA%9A%C2%B7%E5%BC%A5%E8%B5%9B%E5%AE%89%EF%BC%9B%E6%81%A9%E4%BC%AF%E5%B0%94%C2%B7%E5%BF%92%E5%85%B0%E7%8B%84%E4%BA%9A%C2%B7%E4%BC%8A%E8%8A%99-h.jpg"
                                        fit="cover" />
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="6">
                            <router-link to="/article/狐狗狸大人摔倒了_故事背景" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <template #footer>狐狗狸大人摔倒了</template>
                                    <el-image style="width: 100%"
                                        src="https://img.helloworldend.top/gallery/260324-01-%E5%BD%81-h.jpg"
                                        fit="cover" />
                                </el-card>
                            </router-link>
                        </el-col>
                        <el-col :xs="12" :sm="6">
                            <router-link to="/underconstruction" style="font-size: 1.25rem">
                                <el-card shadow="hover">
                                    <template #footer>其他</template>
                                </el-card>
                            </router-link>
                        </el-col>
                    </el-row>
                    <h2 style="padding-top: 2rem;">网站使用指南</h2>
                    <p>→所有<a href="http://helloworldend.top">这个颜色</a>的文字，都是可以跳转的链接。</p>
                    <p>→把鼠标/手指移动到这个图标
                        <el-popover :width="300"
                            popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;">
                            <template #reference>
                                <i class="far fa-question-circle material-icons" />
                            </template>
                            <template #default>
                                <p>是的，这是一段补充说明的内容。</p>
                            </template>
                        </el-popover>
                        上，会弹出一段补充说明的内容。
                    </p>
                    <p>→人物介绍界面经常会出现<span class="mask">这样的防剧透条</span>，把鼠标/手指移动到上面会显示文字内容。</p>
                    <p>→如果觉得逐一点开太麻烦，也可以点击下方的按钮开启/关闭剧透模式，<span class="mask">会让界面上所有的防剧透条都保持显示状态</span>。</p>
                    <button onclick="reveal()" class="reveal-button">剧透模式</button>
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
const title = "Hello,World!"
const subtitle = "关于他们的故事"
</script>
